import * as React from "react";
import { observable, action, IObservableArray } from "mobx";
import { observer, inject } from "mobx-react";
import { hashHistory } from "react-router";
import SeekerStore from "../../../stores/seekerStore";
import { WorkExperience } from "../../../models/profile";
import { IAddJobLocalization, IResumeLocalization } from "../../../models/localization";
import { IInMemLookup } from "../../../models/lookup";
import { JobType } from "../../../models/enums";
import { ParsedResumeResults } from "../../../models/parsedResumeResults";
import { Grid, Row, Col } from "react-flexbox-grid";
import TextField from "material-ui/TextField";
import ResumeNavBtns from "../resumeNavBtns";
import CheckBox from "material-ui/Checkbox";
import Select from "material-ui/Select"
import { MenuItem } from "material-ui/Menu";
import List from "material-ui/List";
import { FormControl, FormControlLabel } from "material-ui/Form";
import { InputLabel } from "material-ui/Input";
import { MMYYRangePicker, MMYYPickValue } from "../../widgets/mmyyPicker";
import DescriptionEditor from "../descriptionEditor";
import ReferenceEditor, { RefField } from "../referenceEditor";
import SkillPicker from "../skillSuggestions";
import Autosuggest from "react-autosuggest";
import Paper from "material-ui/Paper";
import * as s from "./workExperience.css";

@inject("store") @observer
export default class WorkExperienceEditor extends React.Component<{ store: SeekerStore, exp: WorkExperience, fromResume: boolean }, {}> {
    constructor(props: any) {
        super(props);
    }
    @action onChangeMMYY = (val: number, fmt: MMYYPickValue): void => {
        switch (fmt) {
            case MMYYPickValue.FromMon:
                this.props.exp.fromMon = val;
                break;
            case MMYYPickValue.FromYear:
                this.props.exp.fromYear = val;
                break;
            case MMYYPickValue.ToMon:
                this.props.exp.toMon = val;
                break;
            case MMYYPickValue.ToYear:
                this.props.exp.toYear = val;
                break;
            case MMYYPickValue.Current:
                this.props.exp.active = val === 1;
                break;
        }
    }
    @action onChangeReference = (val: string, fmt: RefField): void => {
        switch (fmt) {
            case RefField.Name:
                this.props.exp.refName = val;
                break;
            case RefField.Title:
                this.props.exp.refTitle = val;
                break;
            case RefField.Phone:
                this.props.exp.refPhone = val;
                break;
            case RefField.Contact:
                this.props.exp.refContact = val;
                break;
        }
    }
    @action onChangeLevel = (e: any): void => {
        this.props.exp.level = e.target.value;
    }
    @action onChangeDescription = (val: string): void => {
        this.props.exp.desc = val;
    }
    @action onChangeProperty = (e: any): void => {
        this.props.exp[e.target.name] = e.target.value;
    }
    @action onChangePosition = (e: any): void => {
        this.props.exp.position = e.target.value;
        this.props.exp.refPositionId = null;
        this.props.store.profileStore.clearSuggestedSkills();
        if (this.props.exp.position.length >= 3) {
            this.props.store.profileStore.getSuggestedPositions(this.props.exp.position);
        }
    }
    @action selectPosition = (pos: IInMemLookup): void => {
        this.props.exp.refPositionId = pos.key;
        this.props.exp.position = pos.value;
        this.props.store.profileStore.clearSuggestedPositions();
        this.props.store.profileStore.getSuggestedSkills(null, pos.key);
    }
    renderPositionSuggestions(): JSX.Element {
        if (this.props.store.profileStore.suggestedPositions.length > 0) {
            const items: JSX.Element[] = [];
            this.props.store.profileStore.suggestedPositions.map((p: IInMemLookup, i: number): void => {
                items.push(<MenuItem key={i} value={p.key} onClick={() => this.selectPosition(p)}>{p.value}</MenuItem>);
            });
            return <Row>
              <Col xs={12} sm={6} md={6} lg={4} xl={3}><Paper style={{ marginTop: "-15px" }}>
                    <List>{items}</List>
                </Paper></Col>
            </Row>;
        } else {
            return null;
        }
    }
    clearFocus = (): void => {
      this.props.store.profileStore.clearSuggestedPositions()
    }
    render(): JSX.Element {

        const jobLocal: IAddJobLocalization = this.props.store.localization.fields.addJob;
        const resumeLocal: IResumeLocalization = this.props.store.localization.fields.resume;
        const checked: any = { color: "#5B6770" };
        return (<div>
          {this.props.fromResume && <Row className={s.checkBoxRow}>
                <Col xs={12}>
                    <FormControlLabel label={resumeLocal.addToProfile} control={<CheckBox style={checked} checked={this.props.store.profileStore.srcIncluded("job")}
                        onChange={(e: object, chk: boolean) => this.props.store.profileStore.setSelected("job", chk)} />} />
                </Col>
            </Row>}
          <Row>
            <Col xs={12} sm={6} md={6} lg={4} xl={4} className={s.col}>
              <TextField id="position" label={jobLocal.position} value={this.props.exp.position} onChange={this.onChangePosition} onBlur={() => setTimeout(this.clearFocus, 500)} fullWidth />
            </Col>
            <Col xs={12} sm={6} md={6} lgOffset={2} lg={4} xlOffset={1} xl={4} className={s.col}>
              <TextField name="employer" id="employer" label={jobLocal.employer} value={this.props.exp.employer} onChange={this.onChangeProperty} onFocus={() => this.props.store.profileStore.clearSuggestedPositions()} fullWidth />
                </Col>
            </Row>
            {this.renderPositionSuggestions()}
            <Row>
            <Col xs={12} sm={6} md={6} lg={4} xl={4} className={s.col}>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="level">{jobLocal.expLevelLabel}</InputLabel>
                        <Select value={this.props.exp.level} onChange={this.onChangeProperty} inputProps={{ name: "level", id: "level" }} onFocus={() => this.props.store.profileStore.clearSuggestedPositions()}>
                            <MenuItem value={0}>{jobLocal.expLevel[0]}</MenuItem>
                            <MenuItem value={1}>{jobLocal.expLevel[1]}</MenuItem>
                            <MenuItem value={2}>{jobLocal.expLevel[2]}</MenuItem>
                            <MenuItem value={3}>{jobLocal.expLevel[3]}</MenuItem>
                        </Select>
                    </FormControl>
                </Col>
            </Row>
            <Row className={s.row}>
            <Col xs={12} sm={12} md={6} lg={6} xl={4} >
                    <MMYYRangePicker store={this.props.store} title={jobLocal.workPeriod} fromLabel={jobLocal.from} toLabel={jobLocal.to} fwd={false}
                        currentLabel={jobLocal.current} current={this.props.exp.active} fromMon={this.props.exp.fromMon} fromYr={this.props.exp.fromYear} toMon={this.props.exp.toMon} toYr={this.props.exp.toYear}
                        onChange={this.onChangeMMYY} />
                </Col>
            <Col xs={12} sm={12} md={6} lg={6} xlOffset={1} xl={4}>
                    <ReferenceEditor store={this.props.store} reference={this.props.exp} onChange={this.onChangeReference} />
                </Col>
            </Row>
            <Row>
                <Col xs={12}>
                    <DescriptionEditor store={this.props.store} descriptor={this.props.exp} />
                </Col>
            </Row>
            <SkillPicker store={this.props.store} />
            {this.props.fromResume && <ResumeNavBtns store={this.props.store} />}</div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/profile/workExperienceEditor/index.tsx